import { useSession } from 'next-auth/react';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import { KEYCLOAK_REGISTRATION_URI } from '@config/index';
import { REDIRECT_SCOPE, SESSION_STORAGE_REDIRECT_KEY } from '@features/loginPage/const';
import { TLoginView, TRedirectObject } from '@features/loginPage/typescript';
import LoginCheckout from '@features/loginPage/components/LoginCheckout';
import LoginGeneral from '@features/loginPage/components/LoginGeneral';
import getPublicEnv from '@utils/getPublicEnv';
type PropsType = {
  loginReferer: string;
  showPanel: boolean;
  viewType: TLoginView;
};
const Login = ({
  loginReferer,
  showPanel,
  viewType
}: PropsType) => {
  const router = useRouter();
  const {
    locale
  } = router;
  const {
    query,
    defaultLocale
  } = router;
  const {
    status
  } = useSession();
  const redirectPath: string = typeof query.redirect === 'string' ? query.redirect : viewType.redirectPath;
  if (status === 'authenticated') {
    // TODO - open user panel
    // Zachowaj parametry śledzenia Google Ads
    const currentParams = new URLSearchParams(window.location.search);
    const trackingParams: Record<string, string> = {};
    const trackingParamNames = ['gclid', 'glcid', 'gclsrc', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid', 'msclkid', 'ref'];
    trackingParamNames.forEach(param => {
      const value = currentParams.get(param);
      if (value) {
        trackingParams[param] = value;
      }
    });
    router.push({
      pathname: redirectPath,
      query: trackingParams
    });
  }
  const handleRegister = () => {
    const localePrefix = locale !== defaultLocale ? `/${locale}` : '';
    sessionStorage.setItem(SESSION_STORAGE_REDIRECT_KEY, REDIRECT_SCOPE.checkout);
    const redirectObject: TRedirectObject = {
      pathname: KEYCLOAK_REGISTRATION_URI,
      query: {
        redirect_uri: `${getPublicEnv('NEXT_PUBLIC_HOST')}${localePrefix}/signup`,
        client_id: getPublicEnv('NEXT_PUBLIC_KEYCLOAK_CLIENT_ID'),
        scope: 'openid email profile',
        response_type: 'code'
      }
    };
    if (locale !== defaultLocale) {
      redirectObject.query.ui_locales = locale;
    }
    router.replace(redirectObject);
  };
  return <>
      {viewType.name === 'checkout' ? <LoginCheckout handleRegister={handleRegister} viewType={viewType} redirectPath={redirectPath} /> : <LoginGeneral viewType={viewType} redirectPath={loginReferer || redirectPath} showPanel={showPanel} />}
    </>;
};
export default observer(Login);